<template>
  <transaction-row-base :actualAmount="actualAmount"
                        :out-of-date="outOfDate"
                        :predictedAmount="predictedAmount"
                        :canEditEnvelope="canEditEnvelope"
                        :transactionDate="transactionDate"
                        :transactionDescription="transactionDescription"
                        :isSelected="isSelected"
  />
</template>

<script>
import TransactionDisplayUtils from '../../TransactionDisplayUtils.vue';
import TransactionRowBase from './TransactionRowBase';

export default {
  name: 'PredictedTransactionRow',
  components: { TransactionRowBase },
  mixins: [TransactionDisplayUtils],
  props: {
    predictedTransaction: {
      type: Object,
      required: true,
    },
    canEditEnvelope: {
      type: Boolean,
      required: false,
      default: true,
    },
    showPrediction: {
      type: Boolean,
      required: false,
      default: true,
    },
    isSelected: {
      type: Boolean,
      required: false,
      default: false,
    },
    outOfDate: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    hasActual() {
      return this.predictedTransaction.actual;
    },
    actualAmount() {
      if (this.hasActual) {
        return this.predictedTransaction.actual.billingAmount
          ? this.predictedTransaction.actual.billingAmount
          : this.predictedTransaction.actual.incomeAmount;
      }
      return 0;
    },
    predictedAmount() {
      return this.predictedTransaction.predictedAmount;
    },
    transactionDate() {
      if (this.hasActual) {
        return this.predictedTransaction.actual.transactionDate;
      }

      return '';
    },
    actualBusinessName() {
      return this.predictedTransaction.actual.businessName;
    },
    transactionPayment() {
      return this.getTransactionPayment(this.predictedTransaction.actual);
    },
    transactionAccount() {
      return this.getTransactionAccount(this.predictedTransaction.actual);
    },
    transactionDescription() {
      if (this.hasActual) {
        return `${this.actualBusinessName} ${this.transactionPayment} ${this.transactionAccount}`;
      }
      return this.predictedTransaction.name;
    },
  },
};
</script>
<style scoped lang="scss">

</style>
